var $ = Object.defineProperty;
var L = (t, e, o) => e in t ? $(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o;
var a = (t, e, o) => (L(t, typeof e != "symbol" ? e + "" : e, o), o);
const A = ["monalbumphoto.fr", "photobox.fr"], x = ["posterxxl.de", "b2b.posterxxl.de"];
const g = {
  "albelli.nl": {
    locale: "nl-NL",
    translationLocale: "nl-NL",
    quickReject: !1,
    vendor: "albelli.nl",
    tealiumProfile: "alb"
  },
  "albelli.be": {
    locale: "nl-BE",
    translationLocale: "nl-BE",
    quickReject: !1,
    vendor: "albelli.be",
    tealiumProfile: "alb"
  },
  "bonusprint.co.uk": {
    locale: "en-GB",
    translationLocale: "en-GB",
    quickReject: !1,
    vendor: "bonusprint.co.uk",
    tealiumProfile: "alb"
  },
  "onskefoto.se": {
    locale: "sv-SE",
    translationLocale: "sv-SE",
    quickReject: !1,
    vendor: "onskefoto.se",
    tealiumProfile: "alb"
  },
  "albelli.se": {
    locale: "sv-SE",
    translationLocale: "sv-SE",
    quickReject: !1,
    vendor: "onskefoto.se",
    tealiumProfile: "alb"
  },
  "fotoknudsen.no": {
    locale: "no-NO",
    translationLocale: "no-NO",
    quickReject: !1,
    vendor: "fotoknudsen.no",
    tealiumProfile: "alb"
  },
  "monalbumphoto.fr": {
    locale: "fr-FR",
    translationLocale: "fr-FR",
    quickReject: !0,
    vendor: "monalbumphoto.fr",
    tealiumProfile: "alb"
  },
  "posterxxl.de": {
    locale: "de-DE",
    translationLocale: "de-DE",
    quickReject: !1,
    vendor: "posterxxl.de",
    tealiumProfile: "alb"
  },
  "b2b.posterxxl.de": {
    locale: "de-DE",
    translationLocale: "de-DE",
    quickReject: !1,
    vendor: "b2b.posterxxl.de",
    tealiumProfile: "alb"
  },
  "posterxxl.at": {
    locale: "de-AT",
    translationLocale: "de-AT",
    quickReject: !1,
    vendor: "posterxxl.at",
    tealiumProfile: "alb"
  },
  "hofmann.es": {
    locale: "es-ES",
    translationLocale: "es-ES",
    quickReject: !1,
    vendor: "hofmann.es",
    tealiumProfile: "alb"
  },
  "hofmann.pt": {
    locale: "pt-PT",
    translationLocale: "pt-PT",
    quickReject: !1,
    vendor: "hofmann.pt",
    tealiumProfile: "alb"
  },
  "photobox.dk": {
    locale: "da-DK",
    translationLocale: "da-DK",
    quickReject: !1,
    vendor: "photobox.dk",
    tealiumProfile: "alb"
  },
  "photobox.ie": {
    locale: "en-IE",
    translationLocale: "en-GB",
    quickReject: !1,
    vendor: "photobox.ie",
    tealiumProfile: "alb"
  },
  "photobox.fr": {
    locale: "fr-FR",
    translationLocale: "fr-FR",
    quickReject: !0,
    vendor: "photobox.fr",
    tealiumProfile: "alb"
  },
  "photobox.co.uk": {
    locale: "en-GB",
    translationLocale: "en-GB",
    quickReject: !1,
    vendor: "photobox.co.uk",
    tealiumProfile: "alb"
  },
  "photobox.it": {
    locale: "it-IT",
    translationLocale: "it-IT",
    quickReject: !1,
    vendor: "photobox.it",
    tealiumProfile: "alb"
  }
}, q = "photobox.co.uk", _ = [
  "photobox.co.uk",
  "photobox.it",
  "photobox.fr",
  "photobox.ie",
  "photobox.dk",
  "hofmann.pt",
  "hofmann.es"
];
async function j(t, e) {
  const i = `https://${{
    dev: "t-dtap.",
    devlocal: "t-dtap.",
    tst: "t-dtap.",
    test: "t-dtap.",
    acc: "a-dtap.",
    prod: "",
    prd: ""
  }[e]}storefront-public-conf.albelli.com/${t}`, s = (await fetch(i).then((r) => {
    if (!r.ok)
      throw new Error(`HTTP error! Status: ${r.status}`);
    return r.json();
  }).catch((r) => console.error("Unable to fetch:", r))).menus.bottom.filter(
    (r) => r.text.toLowerCase().includes("kapsler") || r.text.toLowerCase().includes("cookie")
  );
  let c = document.getElementById("cookie-policy-link");
  const d = s[0].href + "?exclude_tracking";
  c.href = d || "";
}
const D = `.arc3-alb,.arc3-hfm,.arc3-pbx,:root{--cc-colour-background-bg-primary: var(--colour-background-bg-primary, #fff);--cc-colour-foreground-fg-white: var(--colour-foreground-fg-white, #fff);--cc-colour-foreground-fg-black: var(--colour-foreground-fg-black, #333);--cc-functional-colours-alpha-alpha-black-15: var(--functional-colours-alpha-alpha-black-15, #33333326);--cc-functional-colours-alpha-alpha-black-45: var(--functional-colours-alpha-alpha-black-45, #33333373);--cc-colour-foreground-fg-primary: var(--colour-foreground-fg-primary, #ff6a13);--cc-colour-foreground-fg-secondary: var(--colour-foreground-fg-secondary, #007377);--cc-colour-borders-border-default: var(--colour-borders-border-default, #ccc);--cc-colour-borders-border-secondary: var(--colour-borders-border-secondary, #007377);--cc-colour-text-text-secondary: var(--colour-text-text-secondary, #007377);--cc-brand-variables-button-radius: var(--brand-variables-button-radius, .25rem)}.cookie-consent-modal *{font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Liberation Sans,sans-serif;color:var(--cc-colour-foreground-fg-black);font-weight:400;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-text-size-adjust:100%}.cookie-consent-modal .cookie-title__content{display:flex}.cookie-consent-modal .cookie-title__child{flex:1}.cookie-consent-modal .cookie-title__child2{flex:1;text-align:right}.cookie-consent-modal h5.cookie-title,.cookie-consent-modal p.cookie-paragraph{color:var(--cc-colour-foreground-fg-black);font-size:16px;line-height:27.04px}.cookie-consent-modal h5.cookie-title{font-weight:700}.cookie-consent-modal .brand-logo{height:32px}.cookie-consent-modal .cookie-setting-link{color:var(--cc-colour-foreground-fg-black);text-decoration:underline;text-decoration-color:var(--colour-foreground-fg-secondary, #007377);font-size:16px;margin:0;padding:0;background:none;border:0;cursor:pointer;-webkit-tap-highlight-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none}.cookie-consent-modal .cookie-setting-link:hover{color:var(--cc-colour-text-text-secondary)}#cookie-policy-link{color:var(--colour-foreground-fg-secondary, #007377)}.cookie-consent-modal .cookie-consent-btn{display:inline-block;padding:11px 48px 15px;color:var(--cc-colour-foreground-fg-white);background-color:var(--cc-colour-foreground-fg-secondary);border:none;border-radius:var(--cc-brand-variables-button-radius);font-size:16px;font-weight:700;text-align:center;text-decoration:none;line-height:normal;cursor:pointer;user-select:none;-webkit-tap-highlight-color:transparent;transition:background-color .3s,border .3s}.cookie-consent-modal .cookie-consent-btn:hover,.cookie-consent-modal .cookie-consent-btn:active,.cookie-consent-modal .cookie-consent-btn:focus{background-image:linear-gradient(0,var(--cc-functional-colours-alpha-alpha-black-15),var(--cc-functional-colours-alpha-alpha-black-15))}.cookie-consent-modal .cookie-consent-btn.--secondary{padding:10px 24px 12px;background-color:transparent;color:var(--cc-colour-foreground-fg-secondary);border:2px solid var(--cc-colour-borders-border-secondary)}.cookie-consent-modal .cookie-consent-btn.--secondary:hover,.cookie-consent-modal .cookie-consent-btn.--secondary:active,.cookie-consent-modal .cookie-consent-btn.--secondary:focus{text-decoration:none;outline:0;background-color:var(--cc-colour-foreground-fg-secondary);color:var(--cc-colour-foreground-fg-white)}@media only screen and (min-width: 600px){.cookie-selection__btn{margin-right:8px}.cookie-selection__buttons{display:flex}.cookie-selection__link{flex:1;text-align:right}}@media only screen and (max-width: 600px){.cookie-selection__btn{margin-bottom:16px}}.cookie-consent-modal *{box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box}body.cookie-consent-modal-open{overflow:hidden}.cookie-consent-modal{display:none;position:fixed;top:0;left:0;right:0;bottom:0;padding:0;margin:0;text-align:center;background-image:linear-gradient(0,var(--cc-functional-colours-alpha-alpha-black-45),var(--cc-functional-colours-alpha-alpha-black-45));z-index:1000;overflow:auto;font-size:0;opacity:0;transition:opacity .3s}.cookie-consent-modal:before{display:inline-block;vertical-align:middle;content:"";font-size:0;height:100%;width:0}@media (min-width: 575px){.cookie-consent-modal{padding:24px 24px 0}}.cookie-consent-modal.--opened{opacity:1;display:block}.cookie-consent-modal .--hide{display:none!important}.cookie-consent-modal .cookie-consent-modal__content{position:relative;display:inline-block;width:auto;max-width:700px;margin-bottom:0;vertical-align:bottom;text-align:left;background-color:var(--cc-colour-background-bg-primary)}@media (min-width: 575px){.cookie-consent-modal .cookie-consent-modal__content{vertical-align:middle;margin-bottom:24px}}.cookie-selection{max-height:100vh;display:flex;flex-direction:column}.cookie-selection h5{margin:0 0 8px}@media (min-width: 575px){.cookie-selection{max-height:calc(100vh - 48px)}}html.os-ios .cookie-selection{max-height:-webkit-fill-available}.cookie-selection__content{overflow:auto;overflow-y:overlay;max-height:calc(100% - 145px);padding:16px}@media (min-width: 575px){.cookie-selection__content{max-height:calc(100% - 81px);padding:24px 24px 8px}}.cookie-selection.--quick .cookie-selection__content{padding-bottom:0}.cookie-selection.--quick .cookie-selection__content p{margin-bottom:8px}.cookie-selection.--quick .cookie-selection__content p:last-of-type{margin-top:8px}.cookie-selection.--full .cookie-selection__content{border-bottom:1px solid var(--cc-colour-borders-border-default)}.cookie-selection__actions{flex-shrink:0;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;padding:16px}@media (min-width: 575px){.cookie-selection__actions{padding:16px 24px}}.cookie-selection__actions>*:first-child{margin:0 0 16px}@media (min-width: 575px){.cookie-selection__actions>*:first-child{margin:0 0 8px}}.cookie-selection__actions .cookie-consent-btn{width:100%}@media (min-width: 575px){.cookie-selection__actions{flex-direction:row}.cookie-selection__actions>*:first-child{margin:0 16px 0 0}.cookie-selection__actions .cookie-consent-btn{width:auto}}.cookie-option{border:1px solid var(--cc-colour-borders-border-default);margin-bottom:8px;position:relative;padding:16px}.cookie-option>div:last-of-type{margin-bottom:16px}.cookie-option label{user-select:none;font-weight:700;padding-right:16px}.cookie-option label input,.cookie-option label span{font-size:16px;font-weight:700}.cookie-option label input:first-of-type,.cookie-option label span:first-of-type{padding-left:8px}.cookie-option:not(.--essential) label{cursor:pointer}.cookie-option__toggle{position:absolute;top:12px;right:8px;cursor:pointer;width:32px;height:32px}.cookie-option__toggle:before,.cookie-option__toggle:after{content:" ";position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;width:10px;height:3px;background-color:var(--cc-colour-foreground-fg-black)}.cookie-option__toggle:after{transform:rotate(90deg)}.cookie-option__toggle:hover:before,.cookie-option__toggle:hover:after{background-color:var(--cc-colour-foreground-fg-secondary)}.cookie-option.--expanded .cookie-option__toggle:after{display:none}.cookie-option__description{display:none}.cookie-option.--expanded{background-color:var(--cc-colour-foreground-fg-primary)}.cookie-option.--expanded .cookie-option__description{display:block}
`, N = {
  "cookieConsentModal.title": "Cookie settings",
  "cookieConsentModal.description": "We use cookies to improve your browsing experience and to be of optimal service to you. By accepting our cookies, we are able to offer you our best experience. If you don't want an optimized experience, you can adjust your cookie settings.",
  "cookieConsentModal.manageSettings": "Manage cookie settings",
  "cookieConsentModal.acceptAll": "Accept all cookies",
  "cookieConsentModal.acceptSelection": "Accept selection",
  "cookieConsentModal.essential.title": "Essential cookies",
  "cookieConsentModal.essential.description": "These cookies are essential to ensure the proper technical functioning of our websites. These cookies are also known as technical or purely functional cookies. Examples include cookies that remember what you have put in your shopping cart or what account you are logged in with.",
  "cookieConsentModal.analytical.title": "Analytical cookies",
  "cookieConsentModal.analytical.description": "We use Adobe Analytics and similar tools to analyse how you use our website. These cookies help us to determine what parts of the website are not clear and what we should improve. This information helps us to improve your user experience.",
  "cookieConsentModal.marketing.title": "Marketing cookies",
  "cookieConsentModal.marketing.description": "Tracking or marketing cookies collect data that we use to serve you the most relevant, personalised advertisements on other websites. Some of the cookies described above may be dropped by third parties when you’re using our website. They may use the cookies to serve ads based on your interest or track your response to their ad. We do not have access to or control over the use of the data collected by these third parties. Please check their Privacy and Cookie Statements for more information. Please note that we do not share any of your personal information we hold in our databases with these third-party companies, except in accordance with our Privacy Policy (you will also find a detailed overview of the specific cookies that are dropped through our websites there)"
}, k = "https://customer-event-tracking", h = "https://tracking-consent", p = {
  devlocal: {
    customerEventTrackingApi: `${k}.t-dtap.sf.albelli.com/api/v1`,
    marketingPixelScript: "http://localhost:9012/marketing-pixel.umd.cjs",
    translations: `${h}.t-dtap.sf.albelli.com/translations`,
    adobeTargetApi: "https://albumprinter.tt.omtrdc.net/rest/v1/delivery?client=albumprinter&sessionId=",
    adobeDataInsertionApi: "https://albumprinter.sc.omtrdc.net/b/ss/albumprinteralbelliglobaldev/0/CODEVERSION?pe=tnt&tnta="
  },
  dev: {
    customerEventTrackingApi: `${k}.t-dtap.sf.albelli.com/api/v1`,
    marketingPixelScript: `${h}.t-dtap.sf.albelli.com/marketing-pixel.umd.cjs`,
    translations: `${h}.t-dtap.sf.albelli.com/translations`,
    adobeTargetApi: "https://albumprinter.tt.omtrdc.net/rest/v1/delivery?client=albumprinter&sessionId=",
    adobeDataInsertionApi: "https://albumprinter.sc.omtrdc.net/b/ss/albumprinteralbelliglobaldev/0/CODEVERSION?pe=tnt&tnta="
  },
  test: {
    customerEventTrackingApi: `${k}.t-dtap.sf.albelli.com/api/v1`,
    marketingPixelScript: `${h}.t-dtap.sf.albelli.com/marketing-pixel.umd.cjs`,
    translations: `${h}.t-dtap.sf.albelli.com/translations`,
    adobeTargetApi: "https://albumprinter.tt.omtrdc.net/rest/v1/delivery?client=albumprinter&sessionId=",
    adobeDataInsertionApi: "https://albumprinter.sc.omtrdc.net/b/ss/albumprinteralbelliglobaldev/0/CODEVERSION?pe=tnt&tnta="
  },
  acc: {
    customerEventTrackingApi: `${k}.a-dtap.sf.albelli.com/api/v1`,
    marketingPixelScript: `${h}.a-dtap.sf.albelli.com/marketing-pixel.umd.cjs`,
    translations: `${h}.a-dtap.sf.albelli.com/translations`,
    adobeTargetApi: "https://albumprinter.tt.omtrdc.net/rest/v1/delivery?client=albumprinter&sessionId=",
    adobeDataInsertionApi: "https://albumprinter.sc.omtrdc.net/b/ss/albumprinteralbelliglobaldev/0/CODEVERSION?pe=tnt&tnta="
  },
  prod: {
    customerEventTrackingApi: `${k}.sf.albelli.com/api/v1`,
    marketingPixelScript: `${h}.sf.albelli.com/marketing-pixel.umd.cjs`,
    translations: `${h}.sf.albelli.com/translations`,
    adobeTargetApi: "https://albumprinter.tt.omtrdc.net/rest/v1/delivery?client=albumprinter&sessionId=",
    adobeDataInsertionApi: "https://albumprinter.sc.omtrdc.net/b/ss/albumprinteralbelliglobal/0/CODEVERSION?pe=tnt&tnta="
  }
};
p.tst = p.test;
p.prd = p.prod;
async function R(t, e) {
  let o, i;
  const n = t && t in g ? g[t].translationLocale : g[q].translationLocale;
  try {
    if (o = await fetch(`${p[e].translations}/${n}.json`), !o.ok)
      throw new Error(`${o.status} ${o.statusText}`);
    i = await o.json();
  } catch (s) {
    let c = "Unknown Error";
    s instanceof Error && (c = s.message), console.error(`Translation file error: ${c}`), i = N;
  }
  return i;
}
class B {
  constructor(e, o) {
    a(this, "vendor");
    a(this, "environment");
    a(this, "translations");
    a(this, "brandName");
    a(this, "env");
    this.vendor = e, this.environment = o, this.env = {
      dev: "tst",
      devlocal: "tst",
      tst: "tst",
      test: "tst",
      acc: "acc",
      prod: "prd",
      prd: "prd"
    }, this.brandName = this.vendor.split(".");
    let i = document.createElement("style");
    i.textContent = D + this.setupModalCompensatorCss(), document.head.appendChild(i);
  }
  /**
   * Create a CSS class to compensate window scrollbar width when modal is opened
   */
  setupModalCompensatorCss() {
    return `body.modal-scroll-compensation { margin-right: ${window.innerWidth - document.documentElement.clientWidth}px; }`;
  }
  async getNodeTree() {
    this.translations = await R(this.vendor, this.environment);
    const e = `<div class="cookie-consent-modal" data-cy="cookie-consent-modal">
                        <div class="cookie-consent-modal__content">
                            ${this.createQuickCookieSelectionNodeTree()}
                            ${this.createFullCookieSelectionNodeTree()}
                        </div>
                      </div>`;
    return document.createRange().createContextualFragment(e);
  }
  /**
   * Create the HTML where the user can do the quick cookie options
   * @returns String
   */
  createQuickCookieSelectionNodeTree() {
    return j(this.vendor, this.environment), `
            <div class="cookie-selection --quick">
                <div class="cookie-selection__content">
                    <div class="cookie-title__content">
                        <div class="cookie-title__child">
                            <h5 class="cookie-title">${this.translate("cookieConsentModal.title")} </h5>
                        </div>
                        <div class="cookie-title__child2">
                            <img class="brand-logo" src="https://storefront-cookie-consent-${this.env[this.environment]}.s3.eu-west-1.amazonaws.com/brand-logo/BrandLogo-${this.brandName[0]}.png" >
                        </div>
                    </div>
                    <p class="cookie-paragraph">${this.translate("cookieConsentModal.description")}</p>
                    <p class="cookie-policy-paragraph cookie-paragraph">
                        <a id="cookie-policy-link" href="" class="cookie-setting-link" data-cy="">${this.translate(
      "cookieConsentModal.cookiePolicy"
    )}</a>
                    </p>
                </div>

                <div class="cookie-selection__actions">
                    <div class="cookie-selection__buttons">
                        <button class="cookie-consent-btn cookie-selection__actions__all cookie-selection__btn" data-cy="cookie-consent-accept-all-button">
                            ${this.translate("cookieConsentModal.acceptAll")}
                        </button>
                        <button class="cookie-consent-btn --secondary cookie-selection__actions__reject --hide" data-cy="cookie-consent-reject-button">
                            ${this.translate("cookieConsentModal.rejectMarketing")}
                        </button>
                        <button class="cookie-consent-btn --secondary cookie-selection-button__actions__manage" data-cy="cookie-consent-manage-settings">
                          ${this.translate("cookieConsentModal.manageSettings")}
                        </button>
                    </div>

                    <div class="cookie-selection__link">
                        <p class="cookie-paragraph cookie-consent-manage-settings-link cookie-setting-left --hide">
                            <a href="" class="cookie-selection__actions__manage cookie-setting-link" data-cy="cookie-consent-manage-settingsFR">${this.translate(
      "cookieConsentModal.manageSettings"
    )}</a>
                        </p>
                    </div>
                </div>
            </div>`;
  }
  /**
   * Create the HTML where the user can select the full cookie options
   * @returns String
   */
  createFullCookieSelectionNodeTree() {
    return `
            <div class="cookie-selection --full --hide">
                <div class="cookie-selection__content">
                    <div class="cookie-option --essential">
                        <label>
                            <input type="checkbox" checked disabled />
                            <span>${this.translate("cookieConsentModal.essential.title")}</span>
                        </label>
                        <span class="cookie-option__toggle"></span>
                        <p class="cookie-paragraph cookie-option__description">
                            ${this.translate("cookieConsentModal.essential.description")}
                        </p>
                    </div>
                    <div class="cookie-option ${!x.includes(this.vendor) && !_.includes(this.vendor) ? "--essential" : ""}">
                        <label>
                            <input type="checkbox" name="analytical" ${!x.includes(this.vendor) && !_.includes(this.vendor) ? "checked disabled" : _.includes(this.vendor) ? "" : "checked"} /><span>
                                ${this.translate("cookieConsentModal.analytical.title")}
                            </span>
                        </label>
                        <span class="cookie-option__toggle"></span>
                        <p class="cookie-paragraph cookie-option__description">
                            ${this.translate("cookieConsentModal.analytical.description")}
                        </p>
                    </div>
                    <div class="cookie-option">
                        <label>
                            <input type="checkbox" name="marketing" />
                            <span>${this.translate("cookieConsentModal.marketing.title")}</span>
                        </label>
                        <span class="cookie-option__toggle"></span>
                        <p class="cookie-paragraph cookie-option__description">
                            ${this.translate("cookieConsentModal.marketing.description")}
                        </p>
                    </div>
                </div>
                <div class="cookie-selection__actions">
                    <button class="cookie-consent-btn --secondary cookie-selection__actions__all" data-cy="cookie-consent-accept-all-button-secondary">
                        ${this.translate("cookieConsentModal.acceptAll")}
                    </button>
                    <button class="cookie-consent-btn --secondary cookie-selection__actions__selected" data-cy="cookie-consent-accept-selected-button">
                        ${this.translate("cookieConsentModal.acceptSelection")}
                    </button>
                </div>
            </div>
        `;
  }
  translate(e) {
    return e in this.translations ? this.translations[e] : e;
  }
}
function m(t) {
  return document.cookie.split("; ").reduce((e, o) => {
    const i = o.split("=");
    return i[0] === t ? decodeURIComponent(i[1]) : e;
  }, "");
}
function U(t) {
  const e = {}, o = document.cookie.split("; ");
  for (let i = 0; i < o.length; i++) {
    const [n, s] = o[i].split("=");
    (!t || n.startsWith(t)) && (e[n] = s ?? "");
  }
  return e;
}
function u(t, e, o, i = 0) {
  let n = "." + t;
  if ((window.Cypress || window.location.href.includes("localhost") || window.location.href.includes("0.0.0.0") || window.location.href.includes("127.0.0.1")) && (n = window.location.hostname.replace("www.", "")), i > 0) {
    const s = new Date();
    s.setTime(s.getTime() + i * 24 * 60 * 60 * 1e3);
    const c = s.toUTCString();
    document.cookie = `${e}=${o};expires=${c};domain=${n};path=/`;
  } else
    document.cookie = `${e}=${o};domain=${n};path=/`;
}
function C(t, e, o) {
  const i = document.createElement("script");
  i.src = p[o].marketingPixelScript;
  const n = function() {
    window.triggerPixels(t, e);
  };
  i.onload = n, document.head.appendChild(i);
}
function V() {
  const t = new Date();
  return `${t.getDate() + "/" + t.getMonth() + "/" + t.getFullYear() + " " + t.getHours() + ":" + ("0" + t.getMinutes()).slice(-2) + ":" + ("0" + t.getSeconds()).slice(-2) + " " + t.getDay()} ${t.getTimezoneOffset()}`;
}
const H = "cookie_consent", E = 365, z = "hideCookieMessage";
class F {
  constructor(e, o) {
    a(this, "modal");
    a(this, "vendor");
    a(this, "vendorObject");
    a(this, "quickSelection");
    a(this, "fullSelection");
    a(this, "acceptAll");
    a(this, "rejectMarketing");
    a(this, "manageSettingsLink");
    a(this, "manageSettingsButton");
    a(this, "cookiePolicy");
    a(this, "acceptSelected");
    a(this, "manageSettings");
    a(this, "options");
    a(this, "inputs");
    if (this.modal = e.querySelector(".cookie-consent-modal"), this.vendor = o, !this.modal)
      return;
    this.vendorObject = g[o], this.quickSelection = this.modal.querySelector(".cookie-selection.--quick .cookie-selection__actions"), this.fullSelection = this.modal.querySelector(".cookie-selection.--full"), this.acceptAll = this.modal.querySelectorAll(".cookie-selection__actions__all"), this.rejectMarketing = this.modal.querySelector(".cookie-selection__actions__reject"), this.manageSettingsLink = this.modal.querySelector(".cookie-consent-manage-settings-link"), this.manageSettingsButton = this.modal.querySelector(".cookie-selection-button__actions__manage"), this.acceptSelected = this.modal.querySelector(".cookie-selection__actions__selected"), this.manageSettings = this.modal.querySelector(".cookie-selection__actions__manage"), this.cookiePolicy = this.modal.querySelector(".cookie-selection.--quick .cookie-selection__content .cookie-policy-paragraph"), this.options = this.modal.querySelectorAll(".cookie-option");
    const i = this.modal.querySelector("input[name=marketing]"), n = this.modal.querySelector("input[name=analytical]");
    this.inputs = {
      marketing: i,
      analytical: n
    }, this.bindSettingsEventListeners(), this.toggleQuickRejectButton(), document.body.appendChild(e);
  }
  /**
   * Show cookie consent modal
   */
  openConsentModal() {
    var e;
    window.preventPoppingUpModals = !0, document.body.classList.add("modal-scroll-compensation"), document.body.classList.add("cookie-consent-modal-open"), (e = this.modal) == null || e.classList.add("--opened"), this.detectIfModalIsBeingHiddenByExternalApp();
  }
  /**
   * Some browsers like Brave or adblockers will stop the modal from opening
   * then we need to remove the scroll-blocking that is in place when the modal is opened
   */
  detectIfModalIsBeingHiddenByExternalApp() {
    var e, o;
    !((e = this.modal) != null && e.checkVisibility()) && ((o = this.modal) != null && o.classList.contains("--opened")) && this.closeModal();
  }
  /**
   * Toggle the "Reject marketing" button depending on
   * whether quick reject should be enabled for that vendor to comply with local regulation
   */
  toggleQuickRejectButton() {
    this.vendorObject.quickReject && this.rejectMarketing && this.manageSettingsLink && this.manageSettingsButton && (this.rejectMarketing.classList.remove("--hide"), this.manageSettingsLink.classList.remove("--hide"), this.manageSettingsButton.classList.add("--hide"));
  }
  bindSettingsEventListeners() {
    this.manageSettings.addEventListener("click", (e) => {
      e.preventDefault(), this.setSelectionView("full");
    }), this.manageSettingsButton.addEventListener("click", (e) => {
      e.preventDefault(), this.setSelectionView("full");
    }), this.options.forEach((e) => {
      const o = e.querySelector(".cookie-option__toggle");
      o && o.addEventListener("click", () => {
        this.options.forEach((i) => {
          const n = i !== e || e.classList.contains("--expanded") ? "remove" : "add";
          i.classList[n]("--expanded");
        });
      });
    });
  }
  /**
   * Bind event listeners to modal buttons
   */
  bindEventListeners() {
    return new Promise((e) => {
      this.acceptAll.forEach((o) => {
        o.addEventListener("click", () => {
          this.closeModal(), e("11");
          const i = { analytical: !0, marketing: !0 };
          this.saveCookies(i);
        });
      }), this.acceptSelected.addEventListener("click", () => {
        this.closeModal(), e(`${this.inputs.analytical.checked ? "1" : "0"}${this.inputs.marketing.checked ? "1" : "0"}`);
        const o = { analytical: this.inputs.analytical.checked, marketing: this.inputs.marketing.checked };
        this.saveCookies(o);
      }), this.rejectMarketing.addEventListener("click", () => {
        this.closeModal(), e("00");
        const o = { analytical: !1, marketing: !1 };
        this.saveCookies(o);
      });
    });
  }
  closeModal() {
    var e;
    this.removeModalBodyHelperClasses(), (e = this.modal) == null || e.classList.remove("--opened");
  }
  /**
   * If the modal is closed let's clean up our helper classes that prevented scrolling and
   * compensated for the scrollbar
   */
  removeModalBodyHelperClasses() {
    document.body.classList.remove("modal-scroll-compensation"), document.body.classList.remove("cookie-consent-modal-open");
  }
  /**
   * Switch between quick and full selection
   */
  setSelectionView(e) {
    const o = e === "full";
    this.quickSelection.classList[o ? "add" : "remove"]("--hide"), this.manageSettings.classList[o ? "add" : "remove"]("--hide"), this.fullSelection.classList[o ? "remove" : "add"]("--hide"), this.cookiePolicy.classList[o ? "add" : "remove"]("--hide");
  }
  /**
   * Save consent flags in cookies
   */
  saveCookies(e) {
    u(
      this.vendor,
      H,
      `${e.analytical ? "1" : "0"}${e.marketing ? "1" : "0"}`,
      E
    ), u(this.vendor, z, "1", E);
  }
}
const y = {
  config: "#f5b222",
  consent: "#489fdf",
  event_tracking: "#38bfc4",
  event_pixel: "#ff6760",
  element_observation: "#224f37",
  target_api: "#f4633a"
};
function K(t) {
  window.debugTrackingConsent = t === "true";
}
function l(t, e, o) {
  window.debugTrackingConsent && console.log(`%c ${e} `, W(t), o);
}
function W(t) {
  return `background-color:${y == null ? void 0 : y[t]}; color: white; padding: 2px 1px; border-radius: 2px;`;
}
function T(t) {
  const e = document.querySelectorAll("[data-click-id]");
  l("element_observation", "Found the following els to observe for click tracking:", e), e.length !== 0 && e.forEach((o) => {
    const i = o.getAttribute("data-click-id");
    i && o.addEventListener("click", () => {
      t.updateTrackedData("banners_click", i), t.trackingEvent("banner_click");
    });
  });
}
function I() {
  const t = document.querySelectorAll("[data-observer-id]");
  if (l("element_observation", "Found the following els to observe for view tracking:", t), t.length === 0)
    return;
  let e = [], o = {
    root: null,
    rootMargin: "0px",
    threshold: 0.75
  }, i = (s) => {
    s.forEach((c) => {
      if (c.isIntersecting) {
        const d = c.target.getAttribute("data-observer-id");
        e.includes(d) || (e.push(d), J(d));
      }
    });
  };
  const n = new IntersectionObserver(i, o);
  t.forEach((s) => n.observe(s));
}
function J(t) {
  const e = localStorage == null ? void 0 : localStorage.getItem("viewedElements");
  let o = e ? JSON.parse(e) : [];
  o.push(t), localStorage == null || localStorage.setItem("viewedElements", JSON.stringify(o)), l("element_observation", "Pushed an element in the localStorage:", t);
}
function X() {
  const t = localStorage == null ? void 0 : localStorage.getItem("viewedElements");
  return l("element_observation", "Found the following els that were viewed on the previous page:", t), t ? (localStorage.setItem("viewedElements", ""), JSON.parse(t)) : !1;
}
function G(t, e, o, i) {
  t === "facebook" ? Q(e, o, i) : t === "google" ? i ? S(e, o, i) : S(e, o) : console.log(`Pixelvendor ${t} is not supported at the moment, consider adding support in the cookieConsent project.`);
}
function Q(t, e, o) {
  const i = () => {
    o ? window.fbq(t, e, o) : window.fbq(t, e);
  };
  typeof window.fbq == "function" ? i() : setTimeout(() => {
    try {
      i();
    } catch (n) {
      console.log("Facebook pixel fbq-function could not be used, producing the following error: ", n);
    }
  }, 1e3);
}
function S() {
  typeof window.dataLayer < "u" ? window.dataLayer.push(arguments) : setTimeout(function() {
    try {
      window.dataLayer.push(arguments);
    } catch (t) {
      console.log("Google pixel dataLayer could not be used, producing the following error: ", t);
    }
  }, 1e3);
}
function Y(t) {
  const e = U("cro_");
  return l("target_api", "Found these cro-cookies:", e), {
    context: {
      channel: "web",
      address: {
        url: new URL(location.pathname, location.href).href
      }
    },
    experienceCloud: {
      analytics: {
        logging: "client_side"
      }
    },
    id: {
      marketingCloudVisitorId: t
    },
    execute: {
      pageLoad: {
        parameters: e
      },
      mboxes: Z(e)
    }
  };
}
function Z(t) {
  return Object.keys(t).map((e, o) => ({
    name: e,
    index: o + 1
  }));
}
async function ee(t, e, o) {
  var i, n, s, c, d;
  try {
    const r = await fetch(`${p[t].adobeTargetApi}${e}`, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(Y(o))
    }), w = ((i = r.headers.get("content-type")) == null ? void 0 : i.includes("application/json")) ? await r.json() : null;
    return w && ((d = (c = (s = (n = w.execute) == null ? void 0 : n.pageLoad) == null ? void 0 : s.analytics) == null ? void 0 : c.payload) != null && d.tnta) ? w.execute.pageLoad.analytics.payload.tnta : null;
  } catch {
    return null;
  }
}
function oe(t, e, o) {
  l("target_api", "Sending tracking event to Data Insertion API:", { marketingCloudVisitorId: e, tntaId: o }), fetch(`${p[t].adobeDataInsertionApi}${o}&mid=${e}`);
}
const M = "network", te = 90, f = "cust_val_mcid", P = "AMCV_096A38B352782D5F0A490D4C%40AdobeOrg", b = 395;
class ie {
  constructor(e, o, i, n, s, c) {
    a(this, "environment");
    a(this, "vendor");
    a(this, "application");
    a(this, "trackingProfile");
    a(this, "queryParams");
    a(this, "overwriteVisitorID");
    this.environment = e, this.vendor = o, this.application = i, this.trackingProfile = n, this.queryParams = s, this.overwriteVisitorID = c;
  }
  async getVisitorId() {
    var e;
    if (m(f))
      return m(f);
    if (this.overwriteVisitorID)
      return u(this.vendor, f, this.overwriteVisitorID, b), u(this.vendor, P, `MCMID|${this.overwriteVisitorID}`, b), this.overwriteVisitorID;
    try {
      const o = await fetch(`${p[this.environment].customerEventTrackingApi}/visitor-id`);
      if (!o.ok)
        throw `Server error: [${o.status}] [${o.statusText}] [${o.url}]`;
      const n = ((e = o.headers.get("content-type")) == null ? void 0 : e.includes("application/json")) ? await o.json() : null;
      return n != null && n.visitorId && (u(this.vendor, f, n == null ? void 0 : n.visitorId, b), u(this.vendor, P, `MCMID|${n == null ? void 0 : n.visitorId}`, b)), l("config", "Retrieved fresh visitorId:", n == null ? void 0 : n.visitorId), n == null ? void 0 : n.visitorId;
    } catch (o) {
      return console.log(o), "";
    }
  }
  setInitialDataObject() {
    var i, n, s, c;
    const e = {
      user_agent: navigator.userAgent,
      banners_click: "",
      browser_height: window.innerHeight,
      browser_width: window.innerWidth,
      resolution: screen.width + "x" + screen.height,
      tracking_code: (i = this.queryParams) == null ? void 0 : i.get("utm_campaign"),
      cookies_enabled: navigator.cookieEnabled ? "Y" : "N",
      page_URL: new URL(location.pathname, location.href).href,
      page_URL_full: location.href,
      page_hostname: location.hostname,
      timestamp: Math.round(Date.now() / 1e3),
      timezone: V(),
      referrer: document.referrer,
      language: window.navigator.language,
      url_without_domain: document.location.pathname,
      url_without_domain_global: ((n = window.TC_data) == null ? void 0 : n.url_without_domain_global) || document.location.pathname,
      // value might be set by clients with proper globalised (e.g. '/photo-books' across vendors), otherwise fallback
      referrerurl_hostname: document.referrer ? new URL(document.referrer).hostname : "",
      vendor_domain_name: this.vendor,
      query_params: Object.fromEntries((s = this.queryParams) == null ? void 0 : s.entries()),
      pageurl_query_param_campaign: (c = this.queryParams) == null ? void 0 : c.get("campaign"),
      application: this.application,
      ...window.AA_data
    }, o = X();
    o && (e.banners = o), window.TC_data = window.TC_data || {}, window.TC_data = { ...window.TC_data, ...e };
  }
  async trackingEvent(e, o) {
    var n;
    window.TC_data.mcid || (window.TC_data.mcid = await this.getVisitorId()), o && Object.keys(o).length && (window.TC_data = { ...window.TC_data, ...o });
    const i = {
      name: e,
      traceId: (n = this.queryParams) == null ? void 0 : n.get("trace_id"),
      profile: this.trackingProfile,
      data: window.TC_data
    };
    l("event_tracking", `Track event fired for ${e}`, i);
    try {
      return fetch(`${p[this.environment].customerEventTrackingApi}/track`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(i)
      });
    } catch (s) {
      return `there was a problem with the trackingEvent request ${s}`;
    }
  }
  /**
   * Updates the TC_data[ key ] contents with the values provided
   */
  updateTrackedData(e, o) {
    l("config", "Updating data object:", { key: e, values: o }), window.TC_data[e] = o;
  }
  /**
   * Network cookie is used by marketing pixels to only fire when a user was targeted in a certain campaign
   */
  setNetworkCookie() {
    var o;
    const e = (o = this.queryParams) == null ? void 0 : o.get("utm_campaign");
    e && (u(this.vendor, M, e, te), l("config", "Network cookie set:", { NETWORK_COOKIE_NAME: M, trackingCode: e }));
  }
}
const O = "cookie_consent", ne = 365, ae = "tc_debug";
class ce {
  constructor(e) {
    a(this, "config");
    a(this, "vendorIsExplicitlyConsent");
    a(this, "vendorIsManualConsent");
    a(this, "cookie");
    a(this, "visitorId");
    a(this, "queryParams");
    a(this, "TrackingHelper");
    /**
     * Allows for Custom events to be send to Tealium
     */
    a(this, "triggerTrackingEvent", async (e, o = {}) => {
      if (!this.vendorIsManualConsent || ["11", "10"].includes(this.cookie))
        return await this.TrackingHelper.trackingEvent(e, o);
    });
    /**
     * Allows for Pixel events to be send to Facebook and Google pixels after page load
     */
    a(this, "triggerPixelEvent", (e, o, i, n = null) => {
      G(e, o, i, n), l("event_pixel", "Track pixel event fired:", { pixelVendor: e, event: o, eventValue: i, eventObject: n });
    });
    a(this, "getTCData", () => window.TC_data);
    /**
     * Starts experiment data tracking for A/B-tests
     */
    a(this, "getExperiment", async () => {
      var i, n;
      let e = m("adobeSessionId");
      e || (e = Math.floor(Math.random() * Math.floor(Math.random() * Date.now())).toString(), u(this.config.vendor, "adobeSessionId", e, 1 / 48)), window.TC_data.mcid || (window.TC_data.mcid = await this.TrackingHelper.getVisitorId());
      const o = await ee((i = this.config) == null ? void 0 : i.environment, e, window.TC_data.mcid);
      l("target_api", "TntaId for Target API:", o), o && oe((n = this.config) == null ? void 0 : n.environment, window.TC_data.mcid, o);
    });
    var o, i, n, s, c, d, r, v;
    this.config = e, this.vendorIsExplicitlyConsent = A.includes(this.config.vendor), this.vendorIsManualConsent = x.includes(this.config.vendor), this.config.vendor = (i = g[(o = this.config) == null ? void 0 : o.vendor]) == null ? void 0 : i.vendor, this.cookie = m(O), this.visitorId = "", this.queryParams = new URLSearchParams(window.location.search), this.TrackingHelper = new ie(
      (n = this.config) == null ? void 0 : n.environment,
      (s = this.config) == null ? void 0 : s.vendor,
      (c = this.config) == null ? void 0 : c.application,
      (r = g[(d = this.config) == null ? void 0 : d.vendor]) == null ? void 0 : r.tealiumProfile,
      this.queryParams,
      (v = this.config) == null ? void 0 : v.overwriteVisitorID
    );
  }
  init() {
    if (K(m(ae)), l("config", "Initialising library with config:", this.config), !this.vendorIsExplicitlyConsent && !this.vendorIsManualConsent && (this.TrackingHelper.setInitialDataObject(), this.TrackingHelper.setNetworkCookie()), !this.config.environment || !this.config.vendor || !Object.keys(g).includes(this.config.vendor)) {
      console.error("Config problem, please verify that you're setting the correct config options");
      return;
    }
    this.triggerTrackingAndPixels();
  }
  async triggerTrackingAndPixels() {
    if (this.queryParams.has("exclude_tracking"))
      return;
    const e = await this.hasConsent();
    l("consent", "Consent cookie set to:", e), !this.vendorIsExplicitlyConsent && !this.vendorIsManualConsent && (window.TC_data.mcid = await this.TrackingHelper.getVisitorId(), this.getExperiment(), this.setAnalyticalTracking(), this.setElementObservers()), e === "01" ? this.setMarketingPixels() : e === "10" ? this.vendorIsManualConsent && (this.setAnalyticalTracking(), this.setElementObservers()) : e === "11" && (this.setMarketingPixels(), (this.vendorIsExplicitlyConsent || this.vendorIsManualConsent) && (this.setAnalyticalTracking(), this.setElementObservers()));
  }
  async setMarketingPixels() {
    (this.vendorIsExplicitlyConsent || this.vendorIsManualConsent) && this.TrackingHelper.setNetworkCookie(), setTimeout(() => {
      document.readyState === "complete" ? C(this.config.vendor, this.config.application, this.config.environment) : window.addEventListener("load", () => {
        C(this.config.vendor, this.config.application, this.config.environment);
      });
    }, 1e3);
  }
  async setAnalyticalTracking() {
    (this.vendorIsExplicitlyConsent || this.vendorIsManualConsent) && (this.TrackingHelper.setInitialDataObject(), window.TC_data.mcid = await this.TrackingHelper.getVisitorId(), this.getExperiment()), this.TrackingHelper.trackingEvent("page_view");
  }
  setElementObservers() {
    document.readyState === "complete" ? (I(), T(this.TrackingHelper)) : window.addEventListener("load", () => {
      I(), T(this.TrackingHelper);
    });
  }
  async showCookieConsentModalUi() {
    const o = await new B(this.config.vendor, this.config.environment).getNodeTree(), i = new F(o, this.config.vendor);
    return new Promise((n) => {
      i.bindEventListeners().then((s) => {
        n(s);
      }), i.openConsentModal();
    });
  }
  hasConsent() {
    return new Promise((e) => {
      let o = {
        detail: {
          consent: ""
        }
      };
      ["0", "1"].includes(this.cookie) && this.formatOldCookieToNewCookie(), this.cookie === "00" ? (o.detail.consent = "00", e("00")) : this.cookie === "01" ? (o.detail.consent = "01", e("01")) : this.cookie === "10" ? (o.detail.consent = "10", e("10")) : this.cookie === "11" ? (o.detail.consent = "11", e("11")) : this.cookie === "" && this.showCookieConsentModalUi().then((n) => {
        o.detail.consent = n, e(n);
      });
      const i = new CustomEvent("userConsent", o);
      window.dispatchEvent(i);
    });
  }
  /**
   * This function is used to convert old cookies to the new format
   */
  formatOldCookieToNewCookie() {
    let e = "";
    this.cookie === "0" ? e = "00" : this.cookie === "1" && (e = "11"), u(this.config.vendor, O, e, ne), this.cookie = e;
  }
}
export {
  ce as TrackingConsent
};
